<script>
	import { capitalizeEachWord } from "cando-util";
	import {
		setDoc,
		addDoc,
		getFirestore,
		doc,
		collection,
	} from "firebase/firestore";
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

	import { store } from "$lib/utilities/store";
	import { translate } from "$lib/utilities/translate";
	import { gotoHref } from "$lib/utilities/handleNav";

	export let col;
	export let lang;
	export let requiredFields = [];
	export let autoGenId = false;
	export let disabled = false;

	let itemId = "";

	$: disabledClass = itemId !== "" ? "" : "opacity-50";
	$: label = capitalizeEachWord(col);

	const addItem = async (e) => {
		e.preventDefault();

		const updates = requiredFields.reduce(
			(a, v) => ({
				...a,
				[v.key]: typeof v.init === "function" ? v.init() : v.init,
			}),
			{},
		);

		if (autoGenId) {
			const newDoc = await addDoc(
				collection(getFirestore(), col),
				updates,
			);
			console.log({ newDoc });

			const href = `${window.location.pathname}?itemId=${newDoc.id}`;

			// this will add any other parameters already in the url
			gotoHref(href); // or you could pass persistSearch = true to keep all the other params
		} else {
			if (!itemId) return;

			await setDoc(doc(getFirestore(), col, itemId), updates, {
				merge: true,
			});

			document.getElementById(`addItem-closeModalCancel`).click();
		}
	};
</script>

{#if autoGenId}
	<div>
		<button
			id="add-new-item-button"
			class="btn btn-sm btn-neutral"
			on:click={addItem}
			{disabled}
		>
			<SvelteFa icon={faCirclePlus} size="1.5x" />
			<span class="hidden sm:inline">
				{translate(
					$store.settings?.docs?.["App Settings"]?.labels?.value?.add,
					lang,
				)}
			</span>
		</button>
	</div>
{:else}
	<div>
		<label
			id="add-new-item-modal-label"
			for={`addItem-modal-toggle`}
			class="btn btn-sm btn-neutral"
		>
			<SvelteFa icon={faCirclePlus} size="1.5x" />
			<span class="hidden sm:inline">
				{translate(
					$store.settings?.docs?.["App Settings"]?.labels?.value?.add,
					lang,
				)}
			</span>
		</label>
		<input
			type="checkbox"
			id={`addItem-modal-toggle`}
			class="modal-toggle"
		/>
		<div class="modal modal-bottom sm:modal-middle">
			<div class="modal-box">
				<div class={`p-2 sm:p-4 group card rounded-2xl shadow-2xl`}>
					<div class="flex flex-col items-center justify-center">
						<div class="flex flex-col items-center justify-center">
							<div class="font-bold">
								Add Document Id for New {label} Document
							</div>
						</div>
						<div
							class="flex flex-col items-center justify-center w-full my-2 sm:my-4"
						>
							<input
								name="itemId"
								id={`itemId-text-input`}
								type="text"
								bind:value={itemId}
								placeholder="enter document id..."
								class={`w-full p-2 sm:p-4 input input-bordered input-primary`}
								required=""
								autocomplete="off"
							/>
						</div>
					</div>
					<button
						id={`addItem-create-button`}
						on:click|preventDefault={addItem}
						class={`my-5 btn btn-neutral rounded-btn sm:my-10 ${disabledClass}`}
					>
						Add {label}
					</button>
					<div class="modal-action">
						<label
							id={`addItem-closeModalCancel`}
							for={`addItem-modal-toggle`}
							class="btn"
						>
							Cancel
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
